import { useState } from 'react'

interface ChildProps<TRowID> {
  readonly activeRowID?: TRowID
  readonly clearActiveRowID: () => void
  readonly updateActiveRowID: (newRowID: TRowID) => void
  readonly hasActiveRowID: boolean
}

export function GridActiveRowManager<TRowID>({
  children
}: {
  readonly children: (props: ChildProps<TRowID>) => any
}) {
  const [activeRowID, setActiveRowID] = useState<TRowID | undefined>(undefined)

  const clearActiveRowID = () => {
    setActiveRowID(undefined)
  }

  const updateActiveRowID = (newActiveRowID: TRowID) => {
    setActiveRowID(activeRowID === newActiveRowID ? undefined : newActiveRowID)
  }

  return children({
    activeRowID,
    clearActiveRowID,
    updateActiveRowID,
    hasActiveRowID: typeof activeRowID !== 'undefined'
  })
}
